import Swiper from "swiper/bundle";
import $ from "jquery";

const employeeVolunteering = {
  methods: {
    initializeSwiper: function () {
      const swiper = new Swiper(".employee-volunteering--swiper", {
        loop: true,
        spaceBetween: 24,
        slidesPerView: 1.5,
        effect: "slide",

        centeredSlides: true,

        navigation: {
          nextEl: ".swiper-button-next-empvol",
          prevEl: ".swiper-button-prev-empvol",
        },
        breakpoints: {
          768: {
            effect: "slide",
            spaceBetween: 67,
            slidesPerView: 1,
          },
        },
      });
    },
  datalayerObj : function (e, el) {
    var obj = {
      'articleName' : "",
      'blogCategory' : "",
      'blogPageCategory' : "",
      'buttonText' : e ? e : "",
      'pageSection' : el ? el : "Employee Volunteering",
      'pageType': document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? window.location.href.includes("blog") ? "Blogs" : window.location.href.substring(window.location.href.indexOf(".com/"), window.location.href.length) === ".com/" ? "Home" : "Other Pages" : "Blog Details Page",
      'planOption' : "",
      'productCategory' : "",
      'productName' : "",
      'question' : "",
      'searchTerm' : "",
      'videoTitle' : "",
      'bannerName' : "",
      'bannerType' : "",
      'leadForm' : "",
  };
  return obj;
  },
  nextClick: function(){
    $(".swiper-button-next-empvol").on('click', function(){
      let section = $(this).closest('.employeeVolunteering');
      let titleText;
      titleText = section.prev('.genericContainer').find('.chli_title .heading-2').text().trim();
      if(titleText==""){
      titleText = section.closest('.genericContainer').prev('.genericContainer').find('.chli_title .heading-2').text().trim();
      }
      let obj = employeeVolunteering.methods.datalayerObj("Next", titleText);
      createDataLayer("List_Scroll_Next", obj);
    });
  },
  prevClick: function(){
    $(".swiper-button-prev-empvol").on('click', function(){
      let section = $(this).closest('.employeeVolunteering');
      let titleText;
      titleText = section.prev('.genericContainer').find('.chli_title .heading-2').text().trim();
      if(titleText==""){
      titleText = section.closest('.genericContainer').prev('.genericContainer').find('.chli_title .heading-2').text().trim();
      }
      let obj = employeeVolunteering.methods.datalayerObj("Previous", titleText);
      createDataLayer("List_Scroll_Previous", obj);
    });
  },
  },
};

$(() => {
  employeeVolunteering.methods.initializeSwiper();
  employeeVolunteering.methods.nextClick();
  employeeVolunteering.methods.prevClick();
});
